import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useApolloClient } from '@apollo/client'

import AuthenticatingPage from './AuthenticatingPage'

import useAppState from '../../hooks/useAppState'
import useTracking from '../../hooks/useTracking'
import useAppSecrets from '../../hooks/useAppSecrets'
import useAsyncEffect from '../../hooks/useAsyncEffect'

import { environment } from '../../../config/environment'
import login from '../../../api/login'
import handleAuthorizationUrl from '../../../util/authorization'

const { activeDirectoryRedirectUri : VITE_ACTIVE_DIRECTORY_REDIRECT_URI } = environment

const AuthenticatingPageWithState = () => {
    const appState = useAppState()
    const location = useLocation()
    const navigate = useNavigate()
    const { trackError } = useTracking()
    const apolloClient = useApolloClient()
    const { activeDirectoryClientId } = useAppSecrets()
    const { search } = location

    useAsyncEffect(async () => {
        const { code, state } = handleAuthorizationUrl(
            search,
            activeDirectoryClientId,
        )
        try {
            const {
                me,
                accessToken,
                accessTokenExpiration,
                refreshToken,
                refreshTokenExpiration,
                refreshTokenSlidingWindowExpiration,
            } = await login(apolloClient, {
                code,
                callBackUrl: VITE_ACTIVE_DIRECTORY_REDIRECT_URI,
                invitationId: state,
            })
            await appState.login(
                accessToken,
                accessTokenExpiration,
                refreshToken,
                refreshTokenExpiration,
                refreshTokenSlidingWindowExpiration,
                me,
            )
            navigate('/')
        } catch (e) {
            trackError(e)
            appState.logout()
            navigate('/login', {
                state: {
                    error: `${
                        state
                            ? 'Your invitation has expired.'
                            : "It's not possible for you to login with your Microsoft account."
                    }`,
                    errorMsg: `Contact your Lexor administrator to invite you or 'Activate login with Microsoft' in your Lexor profile page.`,
                },
            })
        }
    }, [search])

    return <AuthenticatingPage />
}

export default AuthenticatingPageWithState
